import { isMissionNotesDoc, isAdminOnlyDoc } from '../../../utils/docTags';

/** Max chips shown across all groups when a folder is expanded. */
export const ATLAS_PEEK_CHIP_CAP = 16;
/** Max chips shown per group before "+N more". */
export const ATLAS_PEEK_PER_GROUP = 4;

/**
 * Group docs by existing signals (no new type system).
 * Order: Files → Mission notes → Admin-only.
 */
export function groupDocsForPeek(docs = []) {
  const library = [];
  const missionNotes = [];
  const adminOnly = [];

  for (const doc of docs) {
    if (isMissionNotesDoc(doc)) missionNotes.push(doc);
    else if (isAdminOnlyDoc(doc)) adminOnly.push(doc);
    else library.push(doc);
  }

  const groups = [];
  if (library.length) {
    groups.push({ key: 'library', label: 'Files', docs: library });
  }
  if (missionNotes.length) {
    groups.push({ key: 'mission-notes', label: 'Mission notes', docs: missionNotes });
  }
  if (adminOnly.length) {
    groups.push({ key: 'admin-only', label: 'Admin-only', docs: adminOnly });
  }
  return groups;
}

/**
 * Trim groups for the peek: per-group cap + global chip cap.
 * Returns { groups: [{ key, label, shown, more }], totalMore }.
 */
export function trimPeekGroups(groups, {
  perGroup = ATLAS_PEEK_PER_GROUP,
  chipCap = ATLAS_PEEK_CHIP_CAP,
} = {}) {
  let remaining = chipCap;
  const out = [];
  let totalMore = 0;

  for (const g of groups) {
    if (remaining <= 0) {
      totalMore += g.docs.length;
      out.push({
        key: g.key,
        label: g.label,
        shown: [],
        more: g.docs.length,
      });
      continue;
    }
    const take = Math.min(perGroup, g.docs.length, remaining);
    const shown = g.docs.slice(0, take);
    const more = g.docs.length - take;
    remaining -= take;
    totalMore += more;
    out.push({ key: g.key, label: g.label, shown, more });
  }

  return { groups: out, totalMore };
}
